import { isEmpty } from '../../helpers/objectValidator.helper';
import { State } from './selector';

export const getUpdateFlags = (newState: State, oldState: State) => {
    const { address, captcha, error, loading, responseData } = newState;

    return {
        loading: loading !== oldState.loading,
        address: Boolean(address) && address !== oldState.address,
        captchaError: Boolean(captcha?.error),
        captcha: captcha && captcha.validatorUrl !== oldState.captcha?.validatorUrl,
        response: responseData && !isEmpty(responseData),
        error: error && !isEmpty(error),
    };
};
